import { CartOperationlModels, DeadpoolV2OperationalModel } from '~types/index'

const formatOperationalModel = (
  operationalModel: CartOperationlModels
): DeadpoolV2OperationalModel => {
  if (operationalModel === 'PICK_UP') {
    return 'PICK_AND_COLLECT'
  }
  return operationalModel
}

export default formatOperationalModel
